export default {
  canceled: "canceled",
  canceledError: "canceled_error",
  reservationFailed: "reservation_failed",
  claimFailed: "claim_failed",
  reservationSuccess: "reservation_success",
  claimToVerification: "claim_to_verification",
  claimSuccess: "claim_success",
};
